import "./callme.less";
import "../../html/tpl/header";
import "../../html/tpl/footer";
import { getUrlParams } from "../../js/util";
import { post } from "../../js/http";
import Cookies from "js-cookie";
import storage from "good-storage";

$(document).ready(function() {
  let screenWidth = document.body.clientWidth;
  setWH();
  loadIOSDownloadUrl();
  window.onresize = function() {
    screenWidth = document.body.clientWidth;
    setWH();
  };
  function setWH() {
    const cw = document.body.clientWidth;
    let page1Height,
      page2Height,
      page3Height,
      page4Height,
      page5Height,
      page6Height,
      font1,
      font2,
      font3,
      font4,
      font5,
      downboxWH;

    if (cw > 1200) {
      // 设置下载区域宽高
      downboxWH = cw * 0.0885;
      page1Height = (cw * 5) / 12;
      page2Height = (cw * 5) / 12;
      page3Height = (cw * 5) / 12;
      page4Height = (cw * 5) / 12;
      page5Height = (cw * 5) / 12;
      page6Height = (cw * 5) / 12;

      (font1 = ((cw * 50) / 1920).toFixed(5)),
        (font2 = ((cw * 26) / 1920).toFixed(5)),
        (font3 = ((cw * 20) / 1920).toFixed(5)),
        (font4 = ((cw * 39) / 1920).toFixed(5)),
        (font5 = ((cw * 22) / 1920).toFixed(5));
    } else {
      // 设置下载区域宽高
      downboxWH = 1200 * 0.0885;
      page1Height = (1200 * 5) / 12;
      page2Height = (1200 * 5) / 12;
      page3Height = (1200 * 5) / 12;
      page4Height = (1200 * 5) / 12;
      page5Height = (1200 * 5) / 12;
      page6Height = (1200 * 5) / 12;

      (font1 = ((1200 * 50) / 1920).toFixed(5)),
        (font2 = ((1200 * 26) / 1920).toFixed(5)),
        (font3 = ((1200 * 20) / 1920).toFixed(5)),
        (font4 = ((1200 * 39) / 1920).toFixed(5)),
        (font5 = ((1200 * 22) / 1920).toFixed(5));
    }
    $(".callme-down-div").css({
      height: downboxWH,
      width: downboxWH
    });

    $(".page-1-content-1 .callme-font-1").css("font-size", font1 + "px");
    $(".callme-font-2").css("font-size", font2 + "px");
    $(".callme-font-3").css("font-size", font3 + "px");
    $(".callme-font-4").css("font-size", font4 + "px");
    $(".callme-font-5").css("font-size", font5 + "px");

    $("#page1").css({ height: page1Height });
    $("#page2").css({ height: page2Height });
    $("#page3").css({ height: page3Height });
    $("#page4").css({ height: page4Height });
    $("#page5").css({ height: page5Height });
    $("#page6").css({ height: page6Height });
  }
  
  //android下载按钮，获取到链接后在当前页面下载
  $("#android").click(function(){
    let reqParam={
      PackName:"CallMe.PC",
      RuleKey:"Download_Android"
    };
    post("/ApiHome/ApiAction?_ControlName=GetGoPageRuleByPC",reqParam).then(res=>{
      if(res.ReturnStatus&&typeof res.Data.Url!="undefined"){
          let aEl=document.createElement("a");
          aEl.href=res.Data.Url;
          document.body.appendChild(aEl);
          aEl.click();
          document.body.removeChild(aEl);
      }
    })
  });

  function loadIOSDownloadUrl(){
    let reqParam={
      PackName:"CallMe.PC",
      RuleKey:"Download_IOS"
    };
    post("/ApiHome/ApiAction?_ControlName=GetGoPageRuleByPC",reqParam).then(res=>{
      if(res.ReturnStatus&&typeof res.Data.Url!="undefined"){
          $("#ios").attr("href",res.Data.Url);
      }
    })
  };
});

